import { isPresent } from "@suse-o11y/is-present";

import type { Node } from "~/models/dto";

export type NodeWithOwner<TNode extends Node = Node> = Extract<TNode, { ownedBy?: string }>;

export function isNodeOwned<TNode extends NodeWithOwner>(node: TNode): node is TNode & { ownedBy: string } {
	return isPresent(node.ownedBy) && node.ownedBy.length > 0;
}
